import React from 'react';
import {
  ClockCircleOutlined,
  CodeOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

import styles from './InstructionTitle.scss';

const formatSubtitle = (totalQuestion, timer) => {
  const parts = [];

  if (timer > 0) {
    parts.push(
      <span key="timer">
        <ClockCircleOutlined className={styles['icon-secondary']} /> {timer}{' '}
        {timer === 1 ? 'Min' : 'Mins'}
      </span>,
    );
  }

  if (typeof totalQuestion === 'object' && totalQuestion !== null) {
    const { problems = 0, mcqs = 0 } = totalQuestion;
    if (problems > 0) {
      parts.push(
        <span key="problems">
          <CodeOutlined className={styles['icon-secondary']} /> {problems} Problem
          {problems === 1 ? '' : 's'}
        </span>,
      );
    }
    if (mcqs > 0) {
      parts.push(
        <span key="mcqs">
          <CheckCircleOutlined className={styles['icon-secondary']} /> {mcqs} MCQ
          {mcqs === 1 ? '' : 's'}
        </span>,
      );
    }
  } else if (typeof totalQuestion === 'number' && totalQuestion > 0) {
    parts.push(
      <span key="questions">
        <QuestionCircleOutlined className={styles['icon-secondary']} /> {totalQuestion} Question
        {totalQuestion === 1 ? '' : 's'}
      </span>,
    );
  }

  return parts.length > 0
    ? parts.reduce((acc, part, index) => {
        if (index === 0) return [part];
        return [...acc, ' | ', part];
      }, [])
    : null;
};

const InstructionTitle = ({ totalQuestion, timer, title }) => {
  return (
    <div className={styles['title-container']}>
      <h2 className={styles['title-heading']}>{title}</h2>
      <p className={styles['title-subtitle']}>{formatSubtitle(totalQuestion, timer)}</p>
    </div>
  );
};

export default InstructionTitle;
